<script lang="ts">
	import { _ } from 'utils/i18/i18n';

	export let route;
	export let name;
	export let description;
	export let stats;

	let jsonld = JSON.stringify({
		'@context': 'http://schema.org',
		'@type': 'BreadcrumbList',
		itemListElement: [
			{
				'@type': 'ListItem',
				position: 1,
				item: {
					'@id': 'https://cryptomarketcap.com/exchanges',
					name: 'Exchanges',
				},
			},
			{
				'@type': 'ListItem',
				position: 2,
				item: {
					'@id': `https://cryptomarketcap.com/exchanges/${route}`,
					name: `${name} Volume`,
				},
			},
		],
	});

	let jsonld2 = JSON.stringify({
		'@context': 'http://schema.org/',
		'@type': 'FinancialProduct',
		name,
		description,
		category: 'Exchange market volume',
		additionalType: 'Cryptocurrency',
		audience: {
			'@type': 'PeopleAudience',
			suggestedMinAge: 18,
		},
		areaServed: 'Worldwide',
		feesAndCommissionsSpecification: `https://cryptomarketcap.com/exchanges/${route}#statistics`,
		additionalProperty: [
			...Object.entries(stats).map(([name, value]) => ({
				'@type': 'PropertyValue',
				name: $_(`exchange.stats.${name}`),
				value,
			})),
		],
	});

	const jsonldScript = `<script type="application/ld+json">${
		jsonld + '<'
	}/script><script type="application/ld+json">${jsonld2 + '<'}/script>`;
</script>

<svelte:head>
	{@html jsonldScript}
</svelte:head>
